import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-63b077a6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-lg font-medium" }
const _hoisted_2 = { class: "text-gray-300" }
const _hoisted_3 = { class: "text-sm" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-white" }, " • ", -1))
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" of accounts have this achievement ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BadgeIcon = _resolveComponent("BadgeIcon")!
  const _component_Tooltip = _resolveComponent("Tooltip")!

  return (_ctx.achieved)
    ? (_openBlock(), _createBlock(_component_Tooltip, { key: 0 }, {
        trigger: _withCtx(() => [
          _createVNode(_component_BadgeIcon, {
            group: _ctx.group,
            gildClass: _ctx.gildClass,
            class: "w-8 h-8"
          }, null, 8, ["group", "gildClass"])
        ]),
        content: _withCtx(() => [
          _createElementVNode("h5", _hoisted_1, _toDisplayString(_ctx.name), 1),
          _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.description), 1),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", {
              class: _normalizeClass(_ctx.rarityClass)
            }, _toDisplayString(_ctx.rarityName), 3),
            (_ctx.fraction < 1)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _hoisted_4,
                  _createElementVNode("strong", null, _toDisplayString(_ctx.$filters.number.compact(_ctx.fraction * 100)) + "%", 1),
                  _hoisted_5
                ], 64))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}